import type { Location } from 'modules/core/lib/navigation/types'

export const navigation = {
  path: 'engagement',
  children: {
    insights: {
      path: 'insights',
      size: 'full',
      children: {
        launch: {
          size: 'full',
          path: 'launch',
        },
      },
    },
    smart_surveys: {
      path: 'smart_surveys',
      size: 'full',
      children: {
        new: {
          path: 'new',
        },
        overview: {
          path: 'overview',
        },
        classic_surveys: {
          path: 'classic_surveys',
        },
        templates: {
          path: 'templates',
          children: {
            new: {
              path: 'new',
            },
            id: {
              path: ':id',
              children: {
                questions: {
                  path: 'questions',
                },
                settings: {
                  path: 'settings',
                },
              },
            },
          },
        },
        survey: {
          path: ':surveyId',
          children: {
            questions: {
              path: 'questions',
            },
            overview: {
              path: 'overview',
            },
            responses: {
              path: 'responses',
            },
            smartInsights: {
              path: 'smart_insights',
            },
            edit: {
              path: 'edit',
            },
            settings: {
              path: 'settings',
            },
          },
        },
      },
    },
    surveys: {
      path: 'surveys',
      size: 'full',
      children: {
        new: {
          size: 'full',
          path: 'new',
        },
        creation: {
          size: 'full',
          path: 'creation',
        },
        newWorkflowSurvey: {
          size: 'full',
          path: 'new/workflow_survey',
        },
        templates: {
          size: 'full',
          path: 'templates',
        },
        id: {
          level: 2,
          path: ':id',
          children: {
            configuration: {
              level: 2,
              path: 'configuration',
              children: {
                start: {
                  level: 2,
                  path: 'start',
                },
                addManager: {
                  level: 2,
                  path: 'add_manager',
                },
              },
            },
            questions: {
              level: 2,
              path: 'questions',
              children: {
                archiveQuestionConfigId: {
                  level: 2,
                  path: 'archive/:question_config_id',
                },
                unarchiveQuestionConfigId: {
                  level: 2,
                  path: 'unarchive/:question_config_id',
                },
                questionGroupConfigIdAddQuestion: {
                  level: 2,
                  path: ':question_group_config_id/add_question',
                },
                questionGroupConfigIdApplyTemplate: {
                  level: 2,
                  path: ':question_group_config_id/apply_template',
                },
                questionGroupConfigIdAddCategory: {
                  level: 2,
                  path: ':question_group_config_id/add_category',
                },
                questionGroupConfigIdCategoriesQuestionCategoryIdEditCategory: {
                  level: 2,
                  path: ':question_group_config_id/categories/:question_category_id/edit_category',
                },
                questionGroupConfigIdCategoriesQuestionCategoryIdRemoveCategory: {
                  level: 2,
                  path: ':question_group_config_id/categories/:question_category_id/remove_category',
                },
                questionGroupConfigIdCategoriesQuestionCategoryIdAddQuestion: {
                  level: 2,
                  path: ':question_group_config_id/categories/:question_category_id/add_question',
                },
              },
            },
            participants: {
              level: 2,
              path: 'participants',
              children: {
                new: {
                  level: 2,
                  path: 'new',
                },
              },
            },
            responses: {
              level: 2,
              path: 'responses',
              children: {
                questionGroupId: {
                  path: ':question_group_id',
                },
              },
            },
            answer: {
              level: 2,
              path: 'answer',
              children: {
                questionGroupId: {
                  path: ':question_group_id',
                },
              },
            },
            analytics: {
              size: 'full',
              level: 2,
              path: 'analytics',
            },
          },
        },
      },
    },
    enps: {
      path: 'enps',
      size: 'full',
      children: {
        configuration: {
          level: 2,
          path: 'configuration',
        },
        answers: {
          level: 2,
          path: 'answers',
        },
        analytics: {
          level: 2,
          path: 'analytics',
        },
        results: {
          level: 2,
          path: 'results',
        },
      },
    },
    pulse: {
      path: 'pulse',
      children: {
        participation: {
          size: 'full',
          path: 'participation',
        },
        aiReport: {
          size: 'full',
          path: 'ai-report',
        },
      },
    },
    one_on_ones: {
      path: 'one_on_ones',
      children: {
        employeeId: {
          path: ':employeeId',
          children: {
            meetingId: {
              path: 'meeting/:meetingId',
              children: {
                prejoin: {
                  path: 'prejoin',
                },
                room: {
                  path: 'room',
                },
                record: {
                  path: 'record',
                },
              },
            },
          },
        },
        templateId: {
          path: 'template/:templateId',
          children: {
            prejoin: {
              path: 'prejoin',
            },
          },
        },
      },
    },
  },
} as const satisfies Location
